import templateUrl from "emun.order/parts/parts-order-prompt.htm";
import PartsOrderPromptController from "emun.order/parts/parts-order-prompt.controller";
import open from "webmodals/open";

export default options =>
  open({
    size: options.size || "lg",
    templateUrl: options.templateUrl || templateUrl,
    controller: PartsOrderPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  }).result;
